// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { getIconPath, capitalizeWords, isClient } from '@tcp/core/src/utils/utils';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Button from '@tcp/core/src/components/common/atoms/Button';
import PickupBannerStyle from '../styles/PickupBanner.style';
import { getIsStoreBopisEligible, errorOccurred, usePrevious } from './PickupBanner.utils';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GlobalAddToBagLabels,
  GLOBAL_ADD_TO_BAG_MODAL_LABELS,
} from '../../../../../../../utils/labels/globalAddedToBag.labels';

const getHeading = (
  itemAddedForPickup,
  pickupInsteadHeadingSuccess,
  pickupInsteadHeading,
  newPickupInsteadReady
) => {
  const newHeading = newPickupInsteadReady;
  return itemAddedForPickup ? pickupInsteadHeadingSuccess : newHeading;
};

const getIsCallBoopis = () => {
  const { pathname = '' } = (window && window.location) || {};
  return isClient() && (pathname.indexOf('/outfit/') !== -1 || pathname.indexOf('/b/') !== -1);
};

const getStoreSize = () => {
  return 'fs12';
};

const getPickUpFromStoreText = (pickupInsteadFreeOrder, pickupInsteadFromStore) => {
  return pickupInsteadFromStore;
};

const isAddedForPickup = (itemAddedForPickup) => {
  return itemAddedForPickup ? 'green.500' : '';
};

const isShowRedesignBanner = (errorOccured, isAddedToBagRedesign) => {
  return !errorOccured && isAddedToBagRedesign;
};

const getItemAddedForPickup = (itemAddedForPickup, pickupInsteadItemAdded) => {
  return (
    itemAddedForPickup && (
      <BodyCopy component="span" fontWeight="normal" fontFamily="secondary">
        {pickupInsteadItemAdded}
      </BodyCopy>
    )
  );
};

const getPickUpInsteadBtn = (
  itemAddedForPickup,
  onPickupClick,

  pickupInsteadBtnText
) => {
  return (
    !itemAddedForPickup && (
      <Button className="pickup-cta" fill="BLUE" type="button" onClick={onPickupClick}>
        <BodyCopy
          component="span"
          color="white"
          fontWeight="extrabold"
          fontFamily="secondary"
          fontSize={'fs13'}
        >
          {pickupInsteadBtnText}
        </BodyCopy>
      </Button>
    )
  );
};

/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable no-irregular-whitespace */
const PickupBanner = ({
  addedToBagData = {},
  getBopisInventoryDetails,
  userDefaultStore = {},
  bopisItemInventory = [],
  addItemToCartInPickup = () => {},
  addToPickupError = {},
  setAddToPickupError = () => {},
  isAddedToBagRedesign,
}) => {
  const addedToBagLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ADD_TO_BAG_MODAL_LABELS,
    GlobalAddToBagLabels
  );
  const {
    lbl_pickup_instead_heading: pickupInsteadHeading,
    lbl_pickup_instead_heading_success: pickupInsteadHeadingSuccess,
    lbl_pickup_instead_free_order: pickupInsteadFreeOrder,
    lbl_pickup_instead_item_added: pickupInsteadItemAdded,
    lbl_pickup_instead_btn_text: pickupInsteadBtnText,
    lbl_pickup_instead_ready_heading: newPickupInsteadReady,
    lbl_pickup_instead_from_store: pickupInsteadFromStore,
  } = addedToBagLabels;
  const pickupInsteadReady = getDynamicLabelValues('dynamic.global_d.lbl_pickup_instead_ready');
  const { skuInfo = {}, quantity = '', orderItemId: itemId = '', orderId = '' } = addedToBagData;
  const { variantId: itemPartNumber = '', variantNo = '', skuId = '' } = skuInfo;
  const [itemAddedForPickup, updateItemAdded] = useState(false);

  const isStoreBopisEligible = getIsStoreBopisEligible(bopisItemInventory);

  const { basicInfo = {} } = userDefaultStore;
  const { storeName = '', id = '' } = basicInfo;
  const capitalizeStoreName = capitalizeWords(storeName);

  const getInventoryDetails = () => {
    const itemInfo = [
      {
        storeId: id,
        variantNo,
        itemPartNumber,
      },
    ];
    getBopisInventoryDetails({ itemInfo });
  };

  const prevDefaultStoreId = usePrevious(id) || '';
  const isMounted = useRef(null);

  useEffect(() => {
    setAddToPickupError('');
    if (getIsCallBoopis()) {
      getInventoryDetails();
    }
  }, []);

  useEffect(() => {
    if (!isMounted.current && prevDefaultStoreId !== id) {
      getInventoryDetails();
      isMounted.current = true;
    }
  }, [userDefaultStore]);

  const addedCallback = () => {
    updateItemAdded(true);
  };

  const createBossBopisTogglePayload = () => {
    return {
      apiPayload: {
        orderId: `${orderId}`,
        orderItem: [
          {
            orderItemId: itemId,
            xitem_catEntryId: skuId,
            quantity: `${quantity}`,
            variantNo,
            itemPartNumber,
          },
        ],
        x_storeLocId: id,
        x_orderitemtype: 'ECOM', // source type of Item
        x_updatedItemType: 'BOPIS', // target type of Item
      },
      updateActionType: 'UpdatePickUpItem',
      fromTogglingBossBopis: true,
      callback: addedCallback,
      isAddedToBag: true,
    };
  };

  const onPickupClick = () => {
    const payload = createBossBopisTogglePayload();
    addItemToCartInPickup(payload);
  };

  const heading = getHeading(
    itemAddedForPickup,
    pickupInsteadHeadingSuccess,
    pickupInsteadHeading,
    newPickupInsteadReady
  );
  const errorOccured = errorOccurred(addToPickupError);
  return (
    <React.Fragment>
      {isStoreBopisEligible && (
        <PickupBannerStyle isAddedToBagRedesign={isAddedToBagRedesign}>
          {errorOccured && (
            <div className="pickup-banner-container">
              <div className="content-wrap-error">
                <BodyCopy
                  component="p"
                  fontSize="fs16"
                  textAlign="left"
                  fontWeight="extrabold"
                  fontFamily="secondary"
                >
                  {getDynamicLabelValues('dynamic.global_d.lbl_pickup_instead_heading_error')}
                </BodyCopy>
                <BodyCopy
                  component="p"
                  fontSize="fs14"
                  textAlign="left"
                  className="elem-mt-SM error-message-para"
                >
                  <img
                    alt="warning icon"
                    src={getIconPath('circle-warning-fill')}
                    className="error-icon elem-mr-MED"
                  />
                  <BodyCopy component="span" fontWeight="bold" fontFamily="secondary">
                    {getDynamicLabelValues('dynamic.global_d.lbl_pickup_instead_msg_error')}
                  </BodyCopy>
                </BodyCopy>
              </div>
            </div>
          )}
          {isShowRedesignBanner(errorOccured, isAddedToBagRedesign) && (
            <div className="pickup-banner-container pickup-banner-container-redesigned">
              <div className="pickup-banner-heading">
                <BodyCopy
                  component="p"
                  fontSize="fs13"
                  textAlign="left"
                  fontWeight="extrabold"
                  fontFamily="secondary"
                  color={isAddedForPickup(itemAddedForPickup)}
                >
                  {heading}
                </BodyCopy>
              </div>
              <div className="content-wrap">
                <BodyCopy
                  component="p"
                  className="pickup-banner-store-text"
                  fontSize={getStoreSize()}
                  textAlign="left"
                >
                  {!itemAddedForPickup && (
                    <BodyCopy
                      component="span"
                      fontWeight="extrabold"
                      fontFamily="secondary"
                      fontSize="fs12"
                    >
                      {pickupInsteadReady}
                    </BodyCopy>
                  )}
                  {!itemAddedForPickup && (
                    <BodyCopy component="span" fontWeight="normal" fontFamily="secondary">
                      {getPickUpFromStoreText(pickupInsteadFreeOrder, pickupInsteadFromStore)}
                    </BodyCopy>
                  )}
                  {getItemAddedForPickup(itemAddedForPickup, pickupInsteadItemAdded)}
                  <BodyCopy
                    component="span"
                    fontWeight="extrabold"
                    fontFamily="secondary"
                    className="store-name"
                  >
                    {capitalizeStoreName}
                  </BodyCopy>
                </BodyCopy>
                {getPickUpInsteadBtn(itemAddedForPickup, onPickupClick, pickupInsteadBtnText)}
              </div>
            </div>
          )}
          {!errorOccured && !isAddedToBagRedesign && (
            <div className="pickup-banner-container">
              <div className="content-wrap">
                <BodyCopy
                  component="p"
                  fontSize="fs16"
                  textAlign="left"
                  fontWeight="extrabold"
                  fontFamily="secondary"
                  color={isAddedForPickup(itemAddedForPickup)}
                >
                  {heading}
                </BodyCopy>
                <BodyCopy
                  component="p"
                  className="pickup-banner-store-text"
                  fontSize={getStoreSize()}
                  textAlign="left"
                >
                  {!itemAddedForPickup && (
                    <BodyCopy
                      component="span"
                      fontWeight="semibold"
                      color="green.500"
                      fontFamily="secondary"
                    >
                      {pickupInsteadReady}
                    </BodyCopy>
                  )}
                  {!itemAddedForPickup && (
                    <BodyCopy component="span" fontWeight="normal" fontFamily="secondary">
                      {getPickUpFromStoreText(pickupInsteadFreeOrder, pickupInsteadFromStore)}
                    </BodyCopy>
                  )}
                  {getItemAddedForPickup(itemAddedForPickup, pickupInsteadItemAdded)}
                  <BodyCopy
                    component="span"
                    fontWeight="bold"
                    fontFamily="secondary"
                    className="store-name"
                  >
                    {capitalizeStoreName}
                  </BodyCopy>
                </BodyCopy>
              </div>
              {getPickUpInsteadBtn(itemAddedForPickup, onPickupClick, pickupInsteadBtnText)}
            </div>
          )}
        </PickupBannerStyle>
      )}
    </React.Fragment>
  );
};

PickupBanner.propTypes = {
  addedToBagData: PropTypes.shape({}).isRequired,
  userDefaultStore: PropTypes.shape({}).isRequired,
  bopisItemInventory: PropTypes.shape([]).isRequired,
  getBopisInventoryDetails: PropTypes.func.isRequired,
  addItemToCartInPickup: PropTypes.func.isRequired,
  addToPickupError: PropTypes.string.isRequired,
  setAddToPickupError: PropTypes.func.isRequired,
};

export default PickupBanner;
